import React from "react";
import { MdEdit, MdAccessTime } from "react-icons/md";
import { ButtonDelete } from "../../common/Buttons";
import { roleLabel, triggerLabel, ruleLabel, commentStatesLabel } from "../alertHelpers";

function TableColumnAlerts({
  index,
  item,
  page,
  pageCount,
  rules,
  commentStates,
  onEdit,
  onDelete,
  disabled,
}) {
  return (
    <tr className="align-middle tableColumn" key={item.id}>
      <td className="align-middle">{(page - 1) * pageCount + index + 1}</td>
      <td className="align-middle">{item.title || "-"}</td>
      <td className="align-middle">{ruleLabel(item.rule, rules)}</td>
      <td className="align-middle">{commentStatesLabel(item, rules, commentStates)}</td>
      <td className="align-middle">
        <span className="d-flex align-items-center">
          <MdAccessTime className="mr-1" color="#929292" />
          {triggerLabel(item)}
        </span>
      </td>
      <td className="align-middle">{roleLabel(item.role)}</td>
      <td className="align-middle">
        <span
          title={item.active ? "Active" : "Inactive"}
          style={{
            display: "inline-block",
            width: 9,
            height: 9,
            borderRadius: "50%",
            background: item.active ? "#21B451" : "#E8253C",
          }}
        />
      </td>
      <td className="align-middle text-right" style={{ width: "90px" }}>
        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-sm mr-2 d-flex align-items-center justify-content-center"
            style={{ background: "#f29302", width: 29, height: 29, padding: 0 }}
            disabled={disabled}
            onClick={() => onEdit(item)}
            title="Edit alert"
          >
            <MdEdit color="#fff" />
          </button>
          <ButtonDelete disabled={disabled} onDelete={() => onDelete(item.id)} />
        </div>
      </td>
    </tr>
  );
}

export default TableColumnAlerts;
